import { useEffect, useState } from "react";
import client from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Mail, ClipboardCheck } from "lucide-react";
import { toast } from "sonner";

export default function AccessRequests() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const r = await client.get("/platform/access-requests");
        setRows(r.data || []);
      } catch (e) {
        toast.error(e?.response?.data?.detail || "Failed to load access requests");
      } finally { setLoading(false); }
    })();
  }, []);

  return (
    <div className="px-4 py-8 sm:px-8" data-testid="platform-access-requests-page">
      <div className="overline text-teal-700">FlowQA Owner</div>
      <h1 className="font-heading text-3xl font-black tracking-tighter text-slate-900 sm:text-4xl">Access requests</h1>
      <p className="mt-1 text-sm text-slate-600">Submissions from the login page when an email/domain isn&apos;t yet onboarded.</p>

      <Card className="mt-6 overflow-hidden border-slate-200">
        <div className="overflow-x-auto">
          <table className="min-w-full text-sm">
            <thead className="bg-slate-50 text-left text-xs font-semibold uppercase tracking-wider text-slate-600">
              <tr>
                <th className="px-4 py-3">Submitted</th>
                <th className="px-4 py-3">Name / Email</th>
                <th className="px-4 py-3">Company</th>
                <th className="px-4 py-3">Role</th>
                <th className="px-4 py-3">Type</th>
                <th className="px-4 py-3">Message</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {loading && <tr><td colSpan={6} className="px-4 py-6 text-center text-slate-500">Loading…</td></tr>}
              {!loading && rows.length === 0 && (
                <tr><td colSpan={6} className="px-4 py-8 text-center text-slate-500" data-testid="access-requests-empty">
                  <ClipboardCheck className="mx-auto mb-2 size-6 text-slate-300" />
                  No access requests yet.
                </td></tr>
              )}
              {!loading && rows.map((r) => (
                <tr key={r.id} data-testid={`access-request-${r.id}`} className="hover:bg-slate-50">
                  <td className="px-4 py-3 text-xs text-slate-500">{r.created_at ? new Date(r.created_at).toLocaleString() : "—"}</td>
                  <td className="px-4 py-3">
                    <div className="font-semibold text-slate-900">{r.full_name}</div>
                    <div className="text-xs text-slate-500">{r.email}</div>
                  </td>
                  <td className="px-4 py-3 text-slate-700">{r.company_name}</td>
                  <td className="px-4 py-3 text-slate-700">{r.role_title || "—"}</td>
                  <td className="px-4 py-3">
                    <span className="inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-slate-50 px-2 py-0.5 text-xs text-slate-700">
                      <Mail className="size-3" /> {r.request_type === "demo_request" ? "Demo" : "Access"}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-slate-700">{r.message || <span className="text-slate-400">—</span>}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
